export class CasingOrTubingId {
  public casingOrTubingType = '';
  public value = 0;
}

export enum CasingOrTubingDirection {
  horizontal = 'Horizontal',
  vertical = 'Vertical',
  tubing = 'Tubing'
}
